import { SiteConfigManager } from '@atlas/core';

import useLeaveSignupBlocker from './useLeaveSignupBlocker';
import useRegistrationFlowActive from './useRegistrationFlowActive';

const useSignupLeavePopupGuard = ({
  enabled = true,
  history,
  isMultiStepFlow = false,
  isPartiallyRegistered = false,
  onLeave,
  onPopupShown,
  popupType,
  shouldBypassBlock,
}) => {
  const leaveSignup = SiteConfigManager.getConfig(
    'config.config.general.leaveRegistrationPopup.enable',
    false,
  );
  const isLeaveGuardEnabled = leaveSignup && enabled;
  useRegistrationFlowActive({ enabled: isLeaveGuardEnabled && isMultiStepFlow });

  useLeaveSignupBlocker({
    enabled: isLeaveGuardEnabled,
    history,
    isMultiStepFlow,
    isPartiallyRegistered,
    onLeave,
    onPopupShown,
    popupType,
    shouldBypassBlock,
  });
};

export default useSignupLeavePopupGuard;
